"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventsApi = void 0;
var tslib_1 = require("tslib");
var types_1 = require("@wix/ambassador-events-v1-event/types");
var http_1 = require("@wix/ambassador-events-v1-event/http");
var http_2 = require("@wix/ambassador-social-groups-v1-group-event/http");
var types_2 = require("@wix/ambassador-social-groups-v1-group-app/types");
var BaseApi_1 = require("../BaseApi");
var GroupAppsApi_1 = require("../group-apps/GroupAppsApi");
var GroupService_1 = require("../group/GroupService");
var EventsApi = /** @class */ (function (_super) {
    tslib_1.__extends(EventsApi, _super);
    function EventsApi(context) {
        var _this = _super.call(this, context) || this;
        _this.groupAppsService = new GroupAppsApi_1.GroupAppsApi(_this.context);
        _this.groupService = new GroupService_1.GroupService(_this.context);
        return _this;
    }
    EventsApi.prototype.enableEventsTab = function (groupId) {
        return this.groupAppsService.configureApps(groupId, [
            {
                key: types_2.GroupAppKey.EVENTS_APP,
                installed: true,
            },
        ]);
    };
    EventsApi.prototype.getGroupEvents = function (groupId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var eventIds, queryEventsResponse;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getEventIds(groupId)];
                    case 1:
                        eventIds = _a.sent();
                        return [4 /*yield*/, this.queryGroupEvents(eventIds)];
                    case 2:
                        queryEventsResponse = _a.sent();
                        return [2 /*return*/, Object.assign(queryEventsResponse, eventIds)];
                }
            });
        });
    };
    EventsApi.prototype.addToGroup = function (groupId, eventIds) {
        return this.getHTTPClient().request(http_2.addEvents({ groupId: groupId, eventIds: eventIds }));
    };
    EventsApi.prototype.removeFromGroup = function (groupId, eventIds) {
        return this.getHTTPClient().request(http_2.removeEvents({ eventIds: eventIds, groupId: groupId }));
    };
    EventsApi.prototype.getEventGroups = function (eventId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var groupId;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getGroupIdByEventId(eventId)];
                    case 1:
                        groupId = _a.sent();
                        if (!groupId) {
                            return [2 /*return*/, null];
                        }
                        return [2 /*return*/, this.groupService.getGroupById(groupId)];
                }
            });
        });
    };
    EventsApi.prototype.getGroupIdByEventId = function (eventId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, groupId;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, this.getHTTPClient().request(http_2.listGroupsByEventId({
                            eventId: eventId,
                        }))];
                    case 1:
                        _a = tslib_1.__read.apply(void 0, [(_b.sent()).data.groupIds, 1]), groupId = _a[0];
                        return [2 /*return*/, groupId];
                }
            });
        });
    };
    EventsApi.prototype.getEvent = function (id, getEventRequest) {
        if (getEventRequest === void 0) { getEventRequest = {}; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var data;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getHTTPClient().request(http_1.get(tslib_1.__assign({ id: id }, getEventRequest)))];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data];
                }
            });
        });
    };
    EventsApi.prototype.getEventIds = function (groupId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var data;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getHTTPClient().request(http_2.listEvents({ groupId: groupId }))];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data];
                }
            });
        });
    };
    EventsApi.prototype.getEvents = function (limit, fieldset, status) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var listEventsRequest, data;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        listEventsRequest = {
                            fieldset: fieldset || [
                                types_1.EventFieldset.DETAILS,
                                types_1.EventFieldset.DASHBOARD,
                                types_1.EventFieldset.REGISTRATION,
                            ],
                            facet: ['status'],
                            limit: limit,
                            status: status || [
                                types_1.EventStatus.SCHEDULED,
                                types_1.EventStatus.STARTED,
                                types_1.EventStatus.ENDED,
                            ],
                        };
                        return [4 /*yield*/, this.getHTTPClient().request(http_1.list(listEventsRequest))];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data];
                }
            });
        });
    };
    EventsApi.prototype.queryGroupEvents = function (_a, queryEventsV2Request) {
        var eventIds = _a.eventIds;
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var filter, request;
            return tslib_1.__generator(this, function (_b) {
                if (!eventIds.length) {
                    return [2 /*return*/, Promise.resolve({ events: [] })];
                }
                filter = {
                    eventId: {
                        $hasSome: eventIds,
                    },
                    status: {
                        $ne: 'CANCELED',
                    },
                };
                request = tslib_1.__assign({ query: { filter: filter } }, queryEventsV2Request);
                return [2 /*return*/, this.queryEvents(request)];
            });
        });
    };
    EventsApi.prototype.queryEvents = function (queryEventsV2Request) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var qv2r, query, rest, data;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        qv2r = {
                            facet: ['status'],
                            fieldset: [
                                types_1.EventFieldset.DETAILS,
                                types_1.EventFieldset.REGISTRATION,
                                types_1.EventFieldset.URLS,
                            ],
                            query: {
                                sort: [{ fieldName: 'start', order: types_1.SortOrder.ASC }],
                                paging: {
                                    limit: 100,
                                },
                            },
                        };
                        query = queryEventsV2Request.query, rest = tslib_1.__rest(queryEventsV2Request, ["query"]);
                        Object.assign(qv2r, rest);
                        Object.assign(qv2r.query, query);
                        return [4 /*yield*/, this.getHTTPClient().request(http_1.queryV2(qv2r))];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data];
                }
            });
        });
    };
    EventsApi.prototype.listEvents = function (listEventsRequest) {
        if (listEventsRequest === void 0) { listEventsRequest = {}; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _listEventsRequest, data;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _listEventsRequest = {
                            fieldset: [
                                types_1.EventFieldset.DETAILS,
                                types_1.EventFieldset.DASHBOARD,
                                types_1.EventFieldset.REGISTRATION,
                            ],
                            facet: ['status'],
                            limit: 100,
                        };
                        return [4 /*yield*/, this.getHTTPClient().request(http_1.list(Object.assign(_listEventsRequest, listEventsRequest)))];
                    case 1:
                        data = (_a.sent()).data;
                        return [2 /*return*/, data];
                }
            });
        });
    };
    return EventsApi;
}(BaseApi_1.BaseApi));
exports.EventsApi = EventsApi;
//# sourceMappingURL=EventsApi.js.map